import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { downloadFile, formatDateToPtbr, translate } from '../../../../../utils/util';
import ContainerService from '../../../../../services/ContainerService';
import { Breadcrumbs, Button, Collapsible, Fab, Input, Table } from '../../../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../../../utils/handleChangeHooks';
import { checkPermission } from '../../../../../services/auth';
import { PERMISSIONS } from '../../../../../utils/constants';

const PositionList = (props) => {
    const [currentPage, setCurrentPage] = useState({ pageSize: 5, pageIndex: 0, sortField: "", sortOrder: 0 });
    const [positions, setPositions] = useState([]);
    const [filter, setFilter] = useState({});
    const [selectedItems, setSelectedItems] = useState([]);

    useEffect(() => {
        if (props.position?.items) {
            setPositions(props.position.items || []);
        }
        // eslint-disable-next-line
    }, [props?.position?.items]);

    useEffect(() => {
        onSearch(false);
        // eslint-disable-next-line
    }, [currentPage]);

    const onSearch = (click) => {
        props.getPositionPaged({
            ...filter,
            sortField: currentPage.sortField,
            sortOrder: currentPage.sortOrder,
            PageSize: currentPage.pageSize,
            PageIndex: click ? 0 : currentPage.pageIndex
        });
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const exportCsv = () => {
        props.exportCsv(filter, (data) => {
            downloadFile(data, `positions${Date.now()}.csv`, "data:text/csv", false);
        })
    }

    const onCheckItem = (item) => {
        let arr = [];
        Object.assign(arr, selectedItems);
        let index = selectedItems.findIndex((e) => e === item.id);
        if (index === -1) {
            arr.push(item.id)
        } else {
            arr.splice(index, 1);
        }
        setSelectedItems(arr)
    }

    const renderStatus = (status) => {
        switch (status) {
            case 1:
                return <div className={`green-text col s12`} style={{ display: 'block' }}>
                    LIVRE
                </div>
            case 2:
                return <div className={`red-text col s12`} style={{ display: 'block' }}>
                    OCULPADO
                </div>
            case 3:
                return <div className={`red-text col s12`} style={{ display: 'block' }}>
                    BLOQUEADO
                </div>
            default:
                break;
        }
    }

    const configColumn = () => {
        const cols = [
            {
                field: 'id',
                header: "Id",
                align: 'left',
                sortable: false
            },
            {
                field: 'location',
                header: 'Locação',
                align: 'left',
                sortable: true
            }, {
                field: 'queue',
                header: 'Fila',
                align: 'left',
                sortable: true
            },
            {
                field: 'column',
                header: 'Coluna',
                align: 'left',
                sortable: true
            },
            {
                field: 'heightMaxEmpty',
                header: 'Altura Max. Vazio',
                align: 'left',
                sortable: true
            },
            {
                field: 'heightMaxFull',
                header: 'Altura Max. Cheio',
                align: 'left',
                sortable: true
            },
            {
                field: 'heightMaxMixed',
                header: 'Altura(Misto)',
                align: 'left',
                sortable: true
            },
            {
                field: 'status',
                body: (rowData) => renderStatus(rowData.status),
                header: 'Status',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdOn',
                body: (rowData) => formatDateToPtbr(rowData.createdOn),
                header: 'Data Criação',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdBy',
                header: 'Criado Por',
                align: 'left',
            }
        ];
        return cols;
    };

    const configActions = () => [
        {
            function: (row) => (
                <i className="material-icons sixth-text-color"
                    onClick={() => props.deletePosition(row.id, () => {
                        onSearch(true)
                    })}
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'red' }}>delete</i>
            )
        }, {
            function: (row) => (
                <Input
                    type="checkbox"
                    onChange={() => onCheckItem(row)}
                    id="select"
                    name="select"
                    checked={selectedItems.find(f => f === row.id) || false}
                />
            )
        },
    ];

    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: "Posições" }} />
            {
                checkPermission(PERMISSIONS.Warehouse_Container.Config.Patio) &&
                <i className={`mdi mdi-36px mdi-sticker-plus above-btn`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => props.history.push({ pathname: './insert' })} />
            }
            {
                positions.length > 0 && <i className={`mdi mdi-36px mdi-file-excel above-btn`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => exportCsv()} />
            }
            <div className="container-fluid" style={{ marginTop: '40px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="collapsible2"
                        header={translate('expedition:picking.filter')}
                        body={
                            <>
                                <div className="row">
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            id="queue"
                                            name='queue'
                                            label="Fila"
                                            type="text"
                                            defaultValue={filter?.queue || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="column"
                                            name='column'
                                            label="Coluna"
                                            type="number"
                                            defaultValue={filter?.column || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="location"
                                            name='location'
                                            label="Posição"
                                            type="text"
                                            defaultValue={filter?.location || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text="Buscar" onClick={() => onSearch(true)} />
                                </div>
                            </>
                        }
                    />
                </div>
                <div id="areaVirtual" className="container-fluid">
                    <Table
                        totalPages={props.position?.totalPages || 0}
                        current={{ currentPage, setCurrentPage }}
                        col={configColumn()}
                        data={positions}
                        actions={configActions()} />
                </div>
            </div>
            <Fab
                buttons={[
                    { label: translate('change-location:top'), icon: <i className="mdi mdi-publish" />, color: 'darkgreen', onClick: () => { window.scrollTo(0, 0) } },
                    {
                        label: translate('change-location:delete-selected'), icon: <i className="material-icons small sixth-text-color" >delete</i>, color: 'red', onClick: () => {
                            props.deleteListPosition(selectedItems, () => {
                                onSearch(true)
                            })
                        }
                    },
                ]}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        position: state.containerReducer.positionPaged
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPositionPaged: (filter) => {
            dispatch(ContainerService.getPositionPaged(filter));
        },
        deletePosition: (id, callback) => {
            dispatch(ContainerService.deletePosition(id, callback));
        },
        deleteListPosition: (ids, callback) => {
            dispatch(ContainerService.deleteListPosition(ids, callback));
        },
        exportCsv: (filter, callback) => {
            dispatch(ContainerService.exportPositionsCsv(filter, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PositionList));